import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';

import type { CustomerAddress } from './types';

const getCustomerAddresses = async (
  customerId: string
): Promise<BaseResponse<CustomerAddress[], void> | null> => {
  if (!customerId) {
    return null;
  }

  return axios<CustomerAddress[], BaseResponse<CustomerAddress[]>, void>({
    url: `/customers/${customerId}/addresses`,
    method: 'get',
  });
};

export const useCustomerAddresses = (customerId: string) => {
  const [customerAddresses, setCustomerAddresses] = useState<CustomerAddress[]>(
    []
  );

  const { isLoading, data, refetch } = useQuery(
    ['customer-addresses', customerId],
    () => getCustomerAddresses(customerId),
    {
      useErrorBoundary: false,
      refetchOnWindowFocus: true,
      retry: 3,
      enabled: !!customerId,
    }
  );

  useEffect(() => {
    const resultData = data?.data.data;
    const newAddresses = Array.isArray(resultData) ? resultData : [];
    setCustomerAddresses(newAddresses);
  }, [data]);

  return {
    customerAddresses,
    isLoading,
    refetch,
  };
};
